/**
 * Mensagem de uma recusa do servidor. O backend responde regra de negócio como `{ message }`
 * (403/409) OU como texto puro (400 de validação); sem nenhum dos dois, cai no texto padrão.
 */
export const mensagemDoServidor = (e: unknown, padrao: string): string => {
  const data = (e as { response?: { data?: unknown } } | null)?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  const msg = (data as { message?: unknown } | null | undefined)?.message;
  return typeof msg === "string" && msg.trim() ? msg : padrao;
};
